import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Link } from "react-router-dom";

import compose from "recompose/compose";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { FooterText } from "./FooterText";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import Work from "@material-ui/icons/Work";
import CalendarToday from "@material-ui/icons/CalendarToday";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Chat from "@material-ui/icons/Chat";
import MapIcon from "@material-ui/icons/Map";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ExploreIcon from "@material-ui/icons/Explore";
import LocalShipping from "@material-ui/icons/LocalShipping";
import Contacts from "@material-ui/icons/Contacts";
import PersonIcon from "@material-ui/icons/Person";
import BuildIcon from "@material-ui/icons/Build";
import MoreIcon from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

function Footer({ ...props }) {
  const { classes, fluid, white, color, rtlActive } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Link
        to={{
          pathname: `/support`,
        }}
      >
        <MenuItem onClick={handleMenuClose} style={{ color: "black" }}>
          Support
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/settings`,
        }}
      >
        <MenuItem onClick={handleMenuClose} style={{ color: "black" }}>
          Settings
        </MenuItem>
      </Link>
    </Menu>
  );

  const [directoriesAnchorEl, setDirectoriesAnchorEl] = React.useState(null);

  const isDirectoriesMenuOpen = Boolean(directoriesAnchorEl);

  const handleDirectoriesMenuOpen = (event) => {
    setDirectoriesAnchorEl(event.currentTarget);
  };

  const handleDirectoriesMenuClose = () => {
    setDirectoriesAnchorEl(null);
  };

  const directoriesMenuId = "primary-search-directories-menu";
  const renderDirectoriesMenu = (
    <Menu
      anchorEl={directoriesAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={directoriesMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isDirectoriesMenuOpen}
      onClose={handleDirectoriesMenuClose}
    >
      <Link
        to={{
          pathname: `/explore/TEST-users/explore`,
        }}
      >
        <MenuItem
          onClick={handleDirectoriesMenuClose}
          style={{ color: "black" }}
        >
          Users
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/groups`,
        }}
      >
        <MenuItem
          onClick={handleDirectoriesMenuClose}
          style={{ color: "black" }}
        >
          Groups
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/explore/haney-shippers/explore`,
        }}
      >
        <MenuItem
          onClick={handleDirectoriesMenuClose}
          style={{ color: "black" }}
        >
          Shippers
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/explore/haney-vendors/explore`,
        }}
      >
        <MenuItem
          onClick={handleDirectoriesMenuClose}
          style={{ color: "black" }}
        >
          Carriers
        </MenuItem>
      </Link>
    </Menu>
  );

  const [ordersAnchorEl, setOrdersAnchorEl] = React.useState(null);

  const isOrdersMenuOpen = Boolean(ordersAnchorEl);

  const handleOrdersMenuOpen = (event) => {
    setOrdersAnchorEl(event.currentTarget);
  };

  const handleOrdersMenuClose = () => {
    setOrdersAnchorEl(null);
  };

  const ordersMenuId = "primary-search-orders-menu";
  const renderOrdersMenu = (
    <Menu
      anchorEl={ordersAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={ordersMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isOrdersMenuOpen}
      onClose={handleOrdersMenuClose}
    >
      <Link
        to={{
          pathname: `/orders/pending-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Pending
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/quoted-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Quoted
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/booked-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Booked
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/dispatched-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Dispatched
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/in-transit-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          In Transit
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/in-transit-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Docked
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/delivered-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Delivered
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/cancelled-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Cancelled
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/orders/all-orders`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          All
        </MenuItem>
      </Link>
    </Menu>
  );

  const [tripsAnchorEl, setTripsAnchorEl] = React.useState(null);

  const isTripsMenuOpen = Boolean(tripsAnchorEl);

  const handleTripsMenuOpen = (event) => {
    setTripsAnchorEl(event.currentTarget);
  };

  const handleTripsMenuClose = () => {
    setTripsAnchorEl(null);
  };

  const tripsMenuId = "primary-search-trips-menu";
  const renderTripsMenu = (
    <Menu
      anchorEl={tripsAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={tripsMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isTripsMenuOpen}
      onClose={handleTripsMenuClose}
    >
      <Link
        to={{
          pathname: `/trips/create`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          Build Trip
        </MenuItem>
      </Link>
      <Link
        to={{
          pathname: `/trips`,
        }}
      >
        <MenuItem onClick={handleOrdersMenuClose} style={{ color: "black" }}>
          View Trips
        </MenuItem>
      </Link>
    </Menu>
  );

  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white,
    });
  // console.log(props.path);
  if (props.path !== "/ship") {
    return (
      <footer
        style={{
          width: "100%",
        }}
        className={classes.footer}
      >
        <div className={container}>
          {/* <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" aria-label="open drawer">
                <Contacts />
              </IconButton>
              <IconButton color="inherit" >
                <AssignmentIcon />
              </IconButton>
              <Fab color="secondary" aria-label="add" className={classes.fabButton}>
                <LocalShipping />
              </Fab>
              <div className={classes.grow} />
              <IconButton color="inherit">
                <ExploreIcon />
              </IconButton>
              <IconButton edge="end" color="inherit">
                <BuildIcon />
              </IconButton>
            </Toolbar>
          </AppBar> */}
          <div
            className={classes.right}
            style={{ textAlign: "center", width: "100%", padding: "10px 0px" }}
          >
            <GridContainer justify="center">
              <GridItem xs={2}>
                {/* <Link
                    to={{
                      pathname: `/orders/all-orders`,
                    }}
                  > */}
                <MapIcon
                  style={{ color: "#6f6f6f" }}
                  onClick={handleTripsMenuOpen}
                />
                {/* </Link> */}
              </GridItem>
              <GridItem xs={2}>
                {/* <Link
                    to={{
                      pathname: `/trips`,
                    }}
                  > */}
                <ExploreIcon
                  style={{ color: "#6f6f6f" }}
                  onClick={handleOrdersMenuOpen}
                />
                {/* </Link> */}
              </GridItem>
              <GridItem xs={3}>
                {/* <Link
                    to={{
                      pathname: `/ship`,
                    }}
                  >
                    <LocalShipping style={{ color: "#bbb" }} />
                  </Link> */}
                <Link
                  to={{
                    pathname: `/ship`,
                  }}
                >
                  <Fab
                    // color="secondary"
                    aria-label="add"
                    className={classes.fabButton}
                  >
                    <LocalShipping />
                  </Fab>
                </Link>
                <div className={classes.grow} />
              </GridItem>

              <GridItem xs={2}>
                {/* <Link
                    to={{
                      pathname: `/directories`,
                    }}
                  > */}
                <Contacts
                  onClick={handleDirectoriesMenuOpen}
                  style={{ color: "#6f6f6f" }}
                />
                {/* </Link> */}
              </GridItem>
              <GridItem xs={2}>
                {/* <Link
                    to={{
                      pathname: "/trips/create",
                    }}
                  > */}
                <MoreIcon
                  onClick={handleProfileMenuOpen}
                  style={{ color: "#6f6f6f" }}
                />
                {/* </Link> */}
              </GridItem>
            </GridContainer>
            {renderTripsMenu}
            {renderOrdersMenu}
            {renderDirectoriesMenu}
            {renderMenu}
            {/* <FooterText anchor={anchor} rtlActive={rtlActive} /> */}
          </div>
        </div>
      </footer>
    );
  } else {
    return <div />;
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    // uid: state.user.user.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(footerStyle)
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx